import { render, staticRenderFns } from "./voucher.vue?vue&type=template&id=5281b144&"
import script from "./voucher.vue?vue&type=script&lang=js&"
export * from "./voucher.vue?vue&type=script&lang=js&"
import style0 from "./voucher.vue?vue&type=style&index=0&id=5281b144&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.10.1_cache-loader@4.1.0_webpack@4.46.0__css-loader@3.6.0_webpack@4.46.0___8cdfb8a30e6790701421bf10ca45d28a/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports